<template>
  <section v-if="promo" class="promo-result">
    <align small-gap flex>
      <div>
        <div v-if="promo.coupon.name" class="name">
          {{ promo.coupon.name }}
        </div>

        <div class="description">
          {{ promoDescription }}
        </div>
      </div>

      <icon-button icon="close" @click="$emit('clear')" />
    </align>
  </section>
</template>

<script>
export default {
  props: {
    promo: Object,
    isMonthly: Boolean,
  },

  computed: {
    promoDescription() {
      let description = '';

      if (this.promo.coupon.percent_off) {
        description += `${this.promo.coupon.percent_off}% off`;
      } else if (this.promo.coupon.amount_off) {
        description += `${this.$filters.currency(this.promo.coupon.amount_off / 100)} off`;
      }

      if (this.promo.coupon.duration === 'forever') {
        description += ' forever';
      } else if (this.promo.coupon.duration === 'repeating') {
        description += ` for ${this.promo.coupon.duration_in_months} ${this.promo.coupon.duration_in_months === 1 ? 'month' : 'months'}`;
      } else if (this.promo.coupon.duration === 'once') {
        description += ` for 1 ${this.isMonthly ? 'month' : 'year'}`;
      }

      return description;
    },
  },
};
</script>

<style lang="scss" scoped>
.promo-result {
  margin-bottom: $gp;
}

.name {
  text-align: left;
  font-weight: bold;
}

.description {
  text-align: left;
  font-size: 12px;
}
</style>
